import React, { Fragment, useState } from 'react'
import { useLocation } from 'react-router-dom'
import useIsMobile from '../../../../utils/detectDevice'
import { getAuthStore } from '../../../../store/useAuthStore'

export function SwitchProduct(data: any) {
  const [show, setShow] = useState(false)
  const contextRef = React.useRef<HTMLDivElement>(null)
  const { pathname } = useLocation()
  const { isMobile } = useIsMobile(1024)

  function getCurrentPlatformData(platform: string) {
    const currentPlatform = Array.isArray(data?.data)
      ? data.data.find((obj: any) => obj.platform?.toLowerCase() === platform.toLowerCase())
      : undefined
    return currentPlatform?.data
  }

  const products = [
    {
      label: 'CAPTABLE',
      icon: '/media/switchProductIcons/captable.svg',
      redirectURL: process.env.REACT_APP_CAPTABLE_CLIENT_URL,
      bgColor: '#E6EFFF',
      access:
        (getCurrentPlatformData('captable') && getCurrentPlatformData('captable')?.access) || false,
    },
    {
      label: 'ESOP',
      icon: '/media/switchProductIcons/esop.svg',
      redirectURL: process.env.REACT_APP_ESOP_URL,
      bgColor: '#FAF9F3',
      access: (getCurrentPlatformData('esop') && getCurrentPlatformData('esop')?.access) || false,
    },
    {
      label: 'PORTFOLIO',
      icon: '/media/switchProductIcons/portfolio.svg',
      redirectURL: process.env.REACT_APP_INVESTOR_URL,
      bgColor: '#E9FBF3',
      access: false,
    },
    {
      label: 'TASK MANAGER',
      icon: '/media/switchProductIcons/task_manager.svg',
      className: 'px-1',
      redirectURL: process.env.REACT_APP_TASKMANAGER_URL,
      bgColor: '#FEF2E7',
      access:
        (getCurrentPlatformData('taskmanager') && getCurrentPlatformData('taskmanager')?.access) ||
        false,
    },
  ]

  const handleRedirect = (redirectURL: string) => {
    sessionStorage.clear()
    // getAuthStore().clearAuthorization()
    window.location.href = `${redirectURL}`
  }

  return (
    <>
      <div
        className={`menu menu-sub menu-sub-dropdown menu-column menu-rounded-lg menu-gray-600 menu-state-bg menu-state-primary fw-bold py-1 fs-6 w-325px border border-gray-300 ${
          isMobile ? 'mt-12' : 'mt-3'
        } shadow-md`}
        data-kt-menu='true'
        onClick={() => setShow(!show)}
      >
        <div
          className='p-7 row d-flex align-items-start justify-content-between g-4 rounded-md cursor-pointer'
          style={{ gridTemplateColumns: 'repeat(2, 1fr)' }}
        >
          {products.map((product, index) =>
            product.access ? (
              <div
                key={index}
                className={`card p-3 col-6 text-center border mx-2 border-gray-200 d-flex align-items-center justify-content-center${product?.className}`}
                style={{
                  width: '130px',
                  height: '100px',
                }}
                onClick={() => handleRedirect(product?.redirectURL || '')}
                onMouseEnter={(e) => (e.currentTarget.style.background = product.bgColor)}
                onMouseLeave={(e) => (e.currentTarget.style.background = '')}
              >
                <img
                  src={product.icon}
                  alt={product.label}
                  className='img-fluid mt-2'
                  style={{ width: '40px', height: '40px' }}
                />
                <p className='mt-2'>{product.label}</p>
              </div>
            ) : null
          )}
        </div>
      </div>
    </>
  )
}
